import './app.less';
import '../../global.less';
import { Panorama } from '../../pages/pano';
export default function App() {
  return <Panorama />;
}
